import isNode from '../../modules/ajio-util/isNode';

const sendEventGA = ({
  eventCategory = '',
  eventAction = '',
  eventLabel = ''
}: Record<string, string>): void => {
  if (!isNode()) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    window.ga &&
      window.ga('send', {
        hitType: 'event',
        eventCategory,
        eventAction,
        eventLabel
      });
  }
};

// eslint-disable-next-line import/prefer-default-export
export { sendEventGA };
